<!-- 会议细节页面 加入和退出分会 及分会成员 页面点击更多跳转至该页面 -->
<template>
  <div class="meetingMember">
    <!-- 校友数据卡片 -->
    <!--    <div class="alumniDiv">-->
    <!--      <div class="alumniCard clearfix" v-for="item in alumnus" :key="item.id"-->
    <!--        @click="gotoAlumnusDetail(item.userId)">-->
    <!--        <div class="alumniPhotoDiv">-->
    <!--          <img :src="item.url" alt="校友照片" class="alumniPhoto" />-->
    <!--          <div class="sexDiv" v-if="item.sex == 1">-->
    <!--            <img src="../../assets/image/btn_nan_nor.png" alt="性别男" class="sex" />-->
    <!--          </div>-->
    <!--          <div class="sexDiv" v-else>-->
    <!--            <img src="../../assets/image/btn_nv_nor.png" alt="性别女" class="sex" />-->
    <!--          </div>-->
    <!--          <div class="adress" v-if="item.city == myCity">同城</div>-->
    <!--          <div class="adress" v-else>{{ item.city }}</div>-->
    <!--        </div>-->
    <!--        <div class="alumniData">-->
    <!--          <div class="alumniName">{{ item.name }}</div>-->
    <!--          <div class="alumniSchoolAndDissertation">-->
    <!--            {{ item.school }} &nbsp;&nbsp;{{ item.xuejie }}届-->
    <!--          </div>-->
    <!--          <div class="alumniIndustry">从事行业：{{ item.hangye }}</div>-->
    <!--          <div class="alumniCompany">单位：{{ item.danwei }}</div>-->
    <!--          <div class="alumniResources">-->
    <!--            提供资源：{{ item.industry }}-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div style="padding: 2.666667vw">
      <template v-if="alumnus.length > 0">
        <template v-for="item in alumnus" class="alumni-card-box">
          <alumni-info-card :info="item" @go="goAlumniDetail" />
        </template>
      </template>
      <div v-else>
        <van-empty description="没有发现校友" />
      </div>
    </div>
    <div class="signOutDiv" v-if="this.meeting.status == 1">
      <button class="signOutBtn" @click="outMeeting">退出分会</button>
    </div>
  </div>
</template>
<script>
import AlumniInfoCard from "../alumniResources/components/AlumniInfoCard/index.vue";
import Base64 from "@/utils/base64";
export default {
  components: { AlumniInfoCard },
  data() {
    return {
      alumnus: [],
      meeting: "",
      loading: false,
      finished: false,
      myCity: "",
    };
  },
  created() {
    this.getAlumnus();
    this.getMeeting();
    this.getMyCity();
  },
  methods: {
    async getMeeting() {
      let base64 = new Base64()
      const result = await this.$http.get("/branch/getBranchInDetail", {
        params: {
          userId: base64.encode(window.localStorage.getItem("user_id")),
          schoolBranchId: this.$route.query.bid,
        },
      });
      this.meeting = result.data;
    },
    async getAlumnus() {
      const result = await this.$http.get("/branch/getMembersListInBranch", {
        params: { schoolBranchId: this.$route.query.bid },
      });
      // this.alumnus = result.data;
      result.data.forEach((item) => {
        item.aUserId = item.userId;
        item.aUrl = item.url;
        item.aName = item.name;
        item.aDanWei = item.danwei;
        item.aCollege = item.college;
        item.amajor = item.major;
        item.aXuejie = item.xuejie;
        item.aprovince = item.province;
        item.aCity = item.city;
        item.isExchange = false;
        item.aphone = item.phone;
        return item;
      });
      this.alumnus = result.data;
      console.log(this.alumnus);
    },
    goAlumniDetail(e) {
      return this.$router.push({
        path: "/alumniDetailNew",
        query: { alumniId: e },
      });
    },
    gotoAlumnusDetail(userId) {
      if (userId == window.localStorage.getItem("user_id")) {
        return this.$router.push("/myCard");
      }
      return this.$router.push({
        path: "/alumniDetails",
        query: {
          用户Id: userId,
        },
      });
    },
    async outMeeting() {
      // const result = await this.$http({
      //   url: "/branch/quitBranch" + '?' + 'userId=' + parseInt(window.localStorage.getItem("user_id")) + '&' + 'schoolBranchId=' + parseInt(this.$route.query.bid),
      //   method: "POST",
      //   headers: { "Content-Type": 'application/json' },
      // });
      // if (result.data.success == true) {
      //   this.$toast("退出成功");
      //   location.reload();
      // } else {
      //   this.$toast(result.data.msg);
      // }
      const result = await this.$http({
        url: "/branch/quitBranch",
        method: "GET",
        params: {
          userId: parseInt(window.localStorage.getItem("user_id")),
          schoolBranchId: parseInt(this.$route.query.bid),
        },
      });
      if (result.data.success == true) {
        this.$toast("退出成功");
        location.reload();
      } else {
        this.$toast(result.data.msg);
      }
    },
    async getMyCity() {
      let base64 = new Base64()
      const result = await this.$http.get("/my/getBasic", {
        params: { userId: base64.encode(window.localStorage.getItem("user_id")) },
      });
      this.myCity = result.data.city;
    },
  },
};
</script>
<style lang="less" scoped>
.meetingMember {
  position: relative;
}

.search {
  position: relative;
  left: 90%;
  width: 6.5vw;
  max-width: 50px;
}

.searchPopupDiv {
  background-color: #f5f5f5;
  font-size: 1.2em;
  color: #333333;
  font-weight: 600;
  padding: 0px;
  line-height: normal;
}

.searchImg {
  width: 6.5vw;
  max-width: 50px;
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.resourcesPopupSeach {
  position: relative;
  background-color: #f5f5f5;
  height: 8vw;
}

.provincePopupSeach {
  position: relative;
  background-color: #f5f5f5;
  height: 8vw;
}

.popupResources {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;
  font-size: 1.2em;
  font-weight: bold;
  color: #00706E;
}

.popupCity {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20%;
  font-size: 1.2em;
  font-weight: bold;
}

.provincePopupResources {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;
  font-size: 1.2em;
  font-weight: bold;
}

.provincePopupCity {
  float: left;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20%;
  font-size: 1.2em;
  font-weight: bold;
  color: #00706E;
}

.popupSearchDiv {
  position: absolute;
  right: 5%;
  float: left;
}

.popupData {
  height: 80%;
}

.popupDataResources {
  width: 35%;
  height: 100%;
  overflow-y: scroll;
  float: left;
}

.popupDataResources::-webkit-scrollbar {
  display: none;
}

.industry {
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  padding: 15px 0px 15px 0px;
  text-align: center;
  color: #333333;
  font-weight: bold;
}

.province {
  border-width: 0 1px 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  padding: 15px 0px 15px 0px;
  text-align: center;
  color: #333333;
  font-weight: bold;
}

.industryNameDiv {
  position: relative;
  float: right;
  width: 65%;
  height: 100%;
  overflow-y: scroll;
}

.industryNameDiv::-webkit-scrollbar {
  display: none;
}

.industryName {
  position: relative;
  border: 1px solid #bfbfbf;
  width: 35%;
  float: left;
  text-align: center;
  padding: 2%;
  margin-top: 15px;
  left: 8%;
  margin-right: 4%;
  border-radius: 3px;
  color: #333333;
  font-size: 0.9em;
}

.cityNameDiv {
  position: relative;
  float: right;
  width: 65%;
  height: 100%;
  overflow-y: scroll;
}

.cityNameDiv::-webkit-scrollbar {
  display: none;
}

.cityName {
  position: relative;
  border: 1px solid #bfbfbf;
  width: 35%;
  float: left;
  text-align: center;
  padding: 2%;
  margin-top: 15px;
  left: 8%;
  margin-right: 4%;
  border-radius: 3px;
  color: #333333;
  font-size: 0.9em;
}

.btnDiv {
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  width: 100%;
  position: relative;
  height: 13%;
}

.clear {
  width: 35%;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #666666;
}

.getAlumniBtn {
  width: 60%;
  position: absolute;
  left: 35%;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px 0;
  border-radius: 20px;
  border: 0;
  color: white;
  background-image: linear-gradient(to left, #00706E, #00706E);
}

.searchPopup {
  border-radius: 0px !important;
}

.popSearchDataDiv {
  margin-top: 40px;
  width: 90%;
  position: relative;
  left: 5%;
}

.popSearchDataResourcesDiv {
  position: relative;
}

.popSearchDataResourcesName {
  float: left;
  font-size: 1.2em;
  font-weight: bold;
  padding: 20px 0px 20px 10px;
}

.popSearchDataResourcesNum {
  float: left;
  padding: 20px 0px 20px 0px;
  position: absolute;
  left: 85%;
}

.arrowResourcesDiv {
  float: right;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translateY(-50%);
}

hr {
  margin-block-start: 0;
  margin-block-end: 0;
  background-color: #bfbfbf;
  height: 1px;
  border: 0;
}

.popSearchDataCityDiv {
  position: relative;
}

.popSearchDataCity {
  float: left;
  font-size: 1.2em;
  font-weight: bold;
  padding: 20px 0px 20px 10px;
}

.popSearchDataCityNum {
  float: left;
  padding: 20px 0px 20px 0px;
  position: absolute;
  left: 85%;
}

.arrowCityDiv {
  float: right;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translateY(-50%);
}

.popSearchData {
  color: #00706E;
  font-size: 1.2em;
  font-weight: bold;
  height: 85vh;
  overflow: scroll;
}

.popSearchData::-webkit-scrollbar {
  display: none;
}

/deep/.el-form-item__label {
  color: #333333 !important;
  font-size: 1em !important;
  font-weight: bold;
  padding: 20px 0px 0px 10px;
}

/deep/.el-input__inner {
  border: 0;
  background-color: #f5f5f5;
  font-size: 1.1em !important;
  font-weight: normal;
  color: #999999 !important;
}

/deep/.el-form-item {
  margin-bottom: 0 !important;
}

.popSearchInput {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  line-height: 40px;
  padding-left: 15px;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
}

.sexSelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.dateSelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.educationSelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.industrySelect {
  width: 100%;
  border: 0;
  background-color: #f5f5f5;
  border-radius: 5px;
  color: #999999;
  font-weight: normal;
  font-size: 1em;
  height: 40px;
  padding-left: 15px;
  -webkit-appearance: none;
  /*去除chrome浏览器的默认下拉图片*/
  -moz-appearance: none;
  /*去除Firefox浏览器的默认下拉图片*/
}

.searchBtnDiv {
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #bfbfbf;
  width: 100%;
  position: relative;
  height: 8vh;
}

.clear {
  width: 35%;
  text-align: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #666666;
}

.alumniDiv {
  margin-top: 10px;
  border-radius: 0px 0px 15px 15px;
}

.alumniCard {
  position: relative;
  left: 4%;
  width: 92%;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 15px;
  margin-bottom: 20px;
}

.alumniPhotoDiv {
  width: 25%;
  height: 23vw;
  float: left;
  padding: 10px;
  max-height: 200px;
  max-width: 200px;
}

.alumniPhoto {
  width: 100%;
  height: 100%;
  border-radius: 999px;
}

.sexDiv {
  position: absolute;
  left: 21%;
  top: 5%;
}

.sex {
  width: 22px;
  height: 22px;
}

.adress {
  text-align: center;
  font-size: 1em;
  color: #00706E;
  font-weight: 600;
}

.alumniData {
  float: left;
  width: 68%;
  padding-bottom: 10px;
}

.alumniName {
  padding-top: 10px;
  font-size: 1.2em;
  padding-bottom: 10px;
  color: #333333;
  font-weight: 600;
}

.alumniSchoolAndDissertation {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniIndustry {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniCompany {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniResources {
  margin: 2.5px 0px 2.5px 0px;
  color: #666666;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.signOutDiv {
  margin-bottom: 20px;
}

.signOutBtn {
  position: relative;
  left: 4%;
  width: 92%;
  border: 0;
  background: linear-gradient(270deg, #00706E, #00706E);
  color: white;
  font-size: 1.2rem;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/alumniMeeting/MeetingMember.vue